//base
import React, { useCallback, useEffect, useMemo, useState } from 'react';
//style
import { StyledBasicSelect } from './style';
import { themeOptions } from 'styles';

import { commonImage, arrowImage } from 'constants/images';

//libraries
import { InputAdornment } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

export const BasicSelect = ({
  name,
  width,
  label,
  labelName,
  valueName,
  options,
  required,
  sendValue,
  value,
  className,
  onSelected,
  placeholder = 'Select',
  isWhiteIcon = false,
  ...props
}) => {
  const [selectedOption, setSelectedOption] = useState('');

  const selectOptions = useMemo(() => {
    const result = options.map((item) => ({
      label: labelName,
      value: valueName,
      ...item
    }));

    setSelectedOption(value ? value : result[0]?.value);

    return result;
  }, [labelName, options, valueName]);

  const handleChange = (e, child) => {
    setSelectedOption(e.target.value);

    if (onSelected) {
      onSelected(child.props, e);
    }

    if (!sendValue) return;

    sendValue(e, child);
  };

  useEffect(() => {
    if (!value) return;

    setSelectedOption(value);
  }, [value]);

  const [selectOpen, setSelectOpen] = useState(false);

  const handleSelectOpen = (isOpen) => {
    setSelectOpen(isOpen);
  };

  return (
    <StyledBasicSelect width={width} className={className}>
      <span>{label}</span>
      <Select
        name={name}
        label={label}
        open={selectOpen}
        onOpen={() => handleSelectOpen(true)}
        onClose={() => handleSelectOpen(false)}
        value={selectedOption}
        onChange={handleChange}
        IconComponent={() =>
          name === 'language' ? (
            <img src={commonImage.laguage} alt="language" />
          ) : (
            <img
              src={isWhiteIcon ? arrowImage.arrowTriangleWhite : arrowImage.arrowTriangle}
              alt="arrow"
              style={{ cursor: 'pointer' }}
              onClick={() => handleSelectOpen(true)}
            />
          )
        }
        startAdornment={
          required ? (
            <InputAdornment position="start" className="required">
              *{' '}
              <span className="placeholder" style={{ display: value ? 'none' : 'block' }}>
                {placeholder}
              </span>
            </InputAdornment>
          ) : null
        }
        MenuProps={menuProps}
        {...props}
      >
        {selectOptions.map(({ label, value }, i) => {
          return (
            <MenuItem key={i} value={value}>
              {label}
            </MenuItem>
          );
        })}
      </Select>
    </StyledBasicSelect>
  );
};

const menuProps = {
  PaperProps: {
    sx: {
      bgcolor: `${themeOptions.palette.white.main}`,
      padding: '5px',
      margin: '8px 0 0 0',
      borderRadius: '6px',
      border: '1px solid #dadada',
      boxShadow: '0px 4px 10px 0px #0000001A',
      boxSizing: 'border-box',
      '& .MuiMenuItem-root': {
        height: '40px',
        '&:hover': {
          bgcolor: `${themeOptions.palette.green.main} !important`,
          color: `${themeOptions.palette.white.main}`,
          borderRadius: '4px'
        }
      },
      '& .MuiList-root': {
        padding: 0
      },
      '& .Mui-selected': {
        bgcolor: `${themeOptions.palette.green.main} !important`,
        borderRadius: '4px',
        color: `${themeOptions.palette.white.main}`
      }
    }
  }
};
